<template>
  <div class="login-container">
    <div id="header">
      <div id="logo">
        <span
          :class="[
            $GLOBAL_CONFIG.icon === 'zhengzhou.ico' ? 'logo' : 'logo_gd'
          ]"
          :style="{ backgroundImage: `url(${loginLogo})` }"
        ></span
        ><span class="title">{{ $GLOBAL_CONFIG.login.title }}</span>
      </div>
    </div>

    <div class="ad" :style="{ backgroundImage: `url(${loginForeground})` }">
      <div class="login">
        <p class="login-title">登 录</p>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
          <el-form-item prop="userCode">
            <el-input
              v-on:keyup.enter.native="handleLogin()"
              ref="loginFormUserCode"
              size="small"
              v-model="loginForm.userCode"
              @keyup.enter.native="keyupSubmit"
              placeholder="请输入账号"
              clearable
            >
              <i slot="prefix" class="el-input__icon e6-icon-user_line"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="userPassword">
            <el-input
              ref="password"
              @keyup.enter.native="handleLogin()"
              type="password"
              size="small"
              v-model="loginForm.userPassword"
              placeholder="请输入密码"
              clearable
            >
              <i slot="prefix" class="el-input__icon e6-icon-password_line"></i>
            </el-input>
          </el-form-item>

          <el-form-item class="qrcode" prop="verifyCode">
            <div class="code">
              <img
                src="/createImage"
                @click="verifyImgChange()"
                id="verifyImg"
              />
            </div>
            <el-input
              class="code-form-input"
              size="small"
              v-model="loginForm.verifyCode"
            ></el-input>
          </el-form-item>

          <el-form-item prop="rememberMe" class="remanber">
            <ul class="readme-registered">
              <li>
                <el-checkbox v-model="loginForm.rememberMe"
                  >两周内自动登录
                </el-checkbox>
              </li>
              <li>
                <router-link
                  :to="{ path: '/registered' }"
                  class="tag_item"
                  v-if="$GLOBAL_CONFIG.login.isShowRegistButton"
                  >申请注册
                </router-link>
              </li>
            </ul>
          </el-form-item>

          <el-button
            class="button--login"
            size="small"
            type="primary"
            @click="handleLogin"
            :loading="showLoading"
            >登 录
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<style>
@import "~@/assets/styles/index.css";
</style>

<script>
import { mapActions } from "vuex";

const md5 = require("md5");
// 登录页左上角logo
const loginLogo = require(`@/assets/images/${$GLOBAL_CONFIG.imageDirName}/header-logo.png`);
const loginForeground = require(`@/assets/images/${$GLOBAL_CONFIG.imageDirName}/login-foreground.png`);

export default {
  name: "Login",
  data() {
    return {
      loginLogo: Object.freeze(loginLogo),
      loginForeground: Object.freeze(loginForeground),
      showLoading: false,
      loginForm: {
        userCode: "",
        userPassword: "",
        verifyCode: "",
        rememberMe: false
      },
      loginRules: {
        userCode: [{ required: true, message: "请输入账号", trigger: "blur" }],
        userPassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.keyupSubmit();
  },
  methods: {
    ...mapActions(["loginAct"]),
    keyupSubmit() {
      this.$refs.loginFormUserCode.focus();
    },
    verifyImgChange() {
      document.getElementById("verifyImg").src =
        "/createImage?d=" + new Date() * 1;
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.showLoading = true;
          const userCode = this.loginForm.userCode.trim();
          const userPassword = md5(this.loginForm.userPassword);
          const rememberMe = this.loginForm.rememberMe;
          const verifyCode = this.loginForm.verifyCode;
          this.loginAct({ userCode, userPassword, rememberMe, verifyCode })
            .then(response => {
              let code = response.code;
              let type = code === 1 ? "success" : "error";
              this.$message({
                showClose: true,
                message: response.message || "登录失败",
                type,
                duration: 2 * 1000,
                onClose: () => {
                  if (code === 1) {
                    localStorage.userId = response.result.userId;
                    if (response.result.userSourceType === 6) {
                      this.$router.push({ path: "/baseComparyList" });
                    } else {
                      this.$router.push({ path: "/home" });
                    }
                  } else {
                    this.showLoading = false;
                  }
                }
              });
            })
            .catch(error => {
              this.showLoading = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  min-width: 1200px;
  height: 100vh;
  background-image: url("../../assets/images/login-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;

  #header {
    width: 100%;
    background-color: transparent;
    border: none;
    padding-top: 0.21rem;
    padding-left: 0.4rem;

    #logo {
      display: flex;
      align-items: center;
      flex-direction: row;
      // width: 6.54rem;
      // height: 0.74rem;
      // margin: 0;
      // background-image: url("../../assets/images/index-logo.png");
      // background-image: url("../../assets/images/icon_logo.png");
      // background-repeat: no-repeat;
      // background-size: 100% 100%;
      .logo {
        // display: inline-block;
        width: 0.45rem;
        height: 0.37rem;
        // background-image: url("../../assets/images/icon_logo.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .logo_gd {
        width: 0.4rem;
        height: 0.4rem;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .title {
        margin-left: 10px;
        color: #fff;
        font-size: 32px;
        // display: inline-block;
        // height: 0.74rem;
      }
    }
  }

  .ad {
    height: 6.57rem;
    margin-top: 1rem;
    padding: 0 1.4rem 0 1.1rem;
    // background-image: url("../../assets/images/index-main.png");
    background-repeat: no-repeat;
    background-position: 1.1rem 0;
    background-size: 10.14rem 6.57rem;
    position: relative;

    .login {
      width: 4.72rem;
      height: 4.72rem;
      box-sizing: border-box;
      position: absolute;
      right: 1.4rem;
      top: 0.6rem;
      padding: 0.4rem 0.5rem;
      background-image: url("../../assets/images/loginbox.png");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;

      .login-title {
        font-size: 0.24rem;
        color: #ffffff;
        margin: 0 0 0.38rem 0;
        text-align: left;
      }

      /deep/ .el-input__prefix {
        top: 1px;
        left: 10px;
      }

      /deep/ .el-input__inner {
        border-radius: 0.25rem;
        background-color: #2c499a;
        color: #ffffff;
        height: 0.52rem;
      }

      .button--login {
        display: block;
        margin: 0 auto;
        width: 100%;
        height: 0.52rem;
        font-size: 0.2rem;
        margin-top: 0.2rem;
        border-radius: 0.26rem;
        background: linear-gradient(to right, #0389fa, #25e7ff);
        border-color: transparent;
      }
    }
  }

  .login-section {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

    .login-wrap {
      width: 450px;
      height: 250px;
      padding: 10px 60px;
      border: 1px solid #ccc;
      border-radius: 8px;
      box-sizing: border-box;

      h4 {
        text-align: center;
        line-height: 30px;
      }

      .button--login {
        display: block;
        margin: 0 auto;
      }
    }
  }
  .remanber {
    /deep/ .el-checkbox {
      span {
        color: #fff;
      }
    }
  }
  .readme-registered {
    display: flex;
    justify-content: space-between;
  }

  .tag_item {
    flex: 1;
    align-self: center;
    text-align: center;
    color: white;
  }
  .qrcode {
    position: relative;
    .code {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 999;
      height: 100px;
      border-radius: 0.25rem 0 0 0.25rem;
      height: 0.52rem;
      overflow: hidden;
      img {
        height: 100%;
        width: 1.5rem;
      }
    }
    .code-form-input {
      /deep/ .el-input__inner {
        padding-left: 1.65rem;
      }
    }
  }
}
/deep/ .el-input__inner {
  border-color: #627cbb;
}
</style>
